var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#6c7a89"}},[_c('Filtros',{attrs:{"buscarFiltro":_vm.buscarFiltro}}),_c('Mostrar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }